<template>
  <div class="jura-referenzen">
    <b-container>
        <b-row>
            <b-col class="text-center">
              <h1>Referenzen von öffentlichen Ausschreibungen:</h1>
            </b-col>
        </b-row>
        <b-row class="section mt-5">
          <b-col sm="12">
            <h3>Gemeinde Gersheim</h3>
            <ul>
              <li>Neugestaltung Eingangshalle Freibad Walsheim</li>
              <li>Neugestaltung Campinggebäude Walsheim</li>
            </ul>
          </b-col>
        </b-row>
        <b-row class="section mt-5">
          <b-col sm="12">
            <h3>Mittelstadt Völklingen</h3>
            <ul>
              <li>Neugestaltung der Grundschule Luisenthal</li>
            </ul>
          </b-col>
        </b-row>
        <b-row class="section mt-5">
          <b-col sm="12">
            <h3>Gemeinde Großrosseln</h3>
            <ul>
              <li>Sanierung Mehrzweckhalle Emmersweiler</li>
            </ul>
          </b-col>
        </b-row>
        <b-row class="section mt-5">
          <b-col sm="12">
            <h3>Arbeiterwohlfahrt Saarbrücken</h3>
            <ul>
              <li>Umbau und Sanierung AWO Kindertagesstätte, Bexbach</li>
            </ul>
          </b-col>
        </b-row>
        <b-row class="section mt-5">
          <b-col sm="12">
            <h3>Stadt Blieskastel</h3>
            <ul>
              <li>Sanierung der Grundschule Aßweiler</li>
            </ul>
          </b-col>
        </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'start',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.jura-referenzen {
  padding: 40px 0;

  .section {
    background: #f0f0f0;
    padding: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Referenzen.vue